import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import * as appConfig from "appConfig";
import styles from "./FeatureComparisonModal.module.scss";
import { useUi } from "@jelly/lesson";

type FeatureComparisonModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const FeatureComparisonModal: React.FC<FeatureComparisonModalProps> = (props) => {
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <img
        className={styles.speakersSetup}
        src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/introduction/slide4/feature-comparison.jpg`}
        alt="feature-comparison"
      />
    </ui.Modal>
  );
};
